export const ApiURL = 'https://www.wintersbeach.com/apicalls';
export const languageText = 'en';
